import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerFacade, NotificationFacade } from '@ridango/components';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'gl-app-email-confirm',
    template: `
        <rwidget-alert></rwidget-alert>
        <div class="flex h-screen flex-col items-center justify-center gap-4 text-center" *ngIf="isVerifying">
            <ion-spinner name="dots" style="transform: scale(1.5);"></ion-spinner>
        </div>
    `
})
export class EmailConfirmPageComponent implements OnInit {
    loading = true;
    success = false;
    isVerifying = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private customerFacade: CustomerFacade,
        private translate: TranslateService,
        private notification: NotificationFacade
    ) {}

    ngOnInit() {
        this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
            const code = params.get('code');
            if (!code) {
                this.router.navigate([this.translate.currentLang, 'account', 'profile']);
                this.notification.error(this.translate.instant('INTERNAL_ERROR'), { showAfterRouteChange: true });
            }
            this.customerFacade
                .confirmCustomerEmail(code)
                .pipe(take(1))
                .subscribe({
                    next: () => {
                        this.notification.success(this.translate.instant('EMAIL_ADDED_TO_ACCOUNT'), {
                            showAfterRouteChange: true
                        });
                        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
                    },
                    error: (err: HttpErrorResponse) => {
                        const errorKey =
                            typeof err.error === 'string' && err.error.length ? err.error : 'INTERNAL_ERROR';

                        this.notification.error(this.translate.instant(errorKey), { showAfterRouteChange: true });
                        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
                    }
                });
        });
    }
}
